<app-header [title]="'Company Administration'">
  <app-button
    *ngIf="canManageCompanies"
    [black]="true"
    [title]="'+ Create Company'"
    testId="company-create-open"
    (click)="navigateToCreate()"
    header-button
  ></app-button>
</app-header>

<app-response-banner
  [success]="successfulSave"
  [successMessage]="successMessage"
  [errorMessage]="errorMessage"
  [invisible]="!showResponseBanner"
></app-response-banner>

<div class="toolbar">
  <div class="result-count" *ngIf="!companyStore.loading()">
    {{ companyTableData().length }} compan{{
      companyTableData().length === 1 ? 'y' : 'ies'
    }}
  </div>
</div>

<div class="status-card" *ngIf="companyStore.loading()">
  Loading companies...
</div>

<ng-template #companyNameTemplate let-row>
  <a
    class="company-name-link"
    [routerLink]="['/admin/companies', row.id]"
    (click)="$event.stopPropagation()"
  >
    {{ row.name }}
  </a>
</ng-template>

<qs-table
  *ngIf="!companyStore.loading()"
  [data]="companyTableData()"
  [columns]="companyColumns()"
  [isSearchEnabled]="true"
  [isPaginatorEnabled]="true"
  [paginatorConfig]="tablePaginatorConfig"
>
</qs-table>
